/**
 * ∅ NULLGOLF — TE motion system (REV A)
 *
 * Scroll-triggered reveal engine + hero scan reveal + scroll trace +
 * card hover scramble + sticky add-to-cart. Ported from the design
 * prototype ("Null Golf — Motion Demo").
 *
 * Reveal kinds ([data-rv], optional [data-rv-d] delay in ms):
 *   rise    — opacity 0→1 (480ms) + translateY 26px→0 (560ms SNAP)
 *   fade    — opacity 0→1 (420ms)
 *   stamp   — opacity 0→1 (200ms) + scale 1.12→1 (260ms SNAP)
 *   drawY   — green left border fades in (400ms) + content fade (300ms)
 *   specrow — opacity + translateX −14px→0 (300/360ms)
 *   type    — typewriter (~16ms/char) with green caret
 *   scr     — character scramble resolving left→right
 *
 * Everything respects prefers-reduced-motion (reveals skipped, loops off).
 */
(function () {
  'use strict';

  var SNAP = 'cubic-bezier(0.2, 0, 0, 1)';
  var GREEN = '#1E7A44';
  var SCRAMBLE_CHARS = '∅0123456789ABCDEF/·';

  var reducedQuery = null;
  var reduced = false;
  try {
    reducedQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    reduced = reducedQuery.matches;
  } catch (e) {
    /* noop */
  }

  var timers = [];
  var activeObserver = null;
  function later(fn, ms) {
    var t = setTimeout(fn, ms);
    timers.push(t);
    return t;
  }

  /* ── scroll progress trace ─────────────────────────────────── */
  function setupScrollTrace() {
    var el = document.querySelector('[data-scroll-trace]');
    if (!el) return;
    var ticking = false;
    var update = function () {
      ticking = false;
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      el.style.transform = 'scaleX(' + (max > 0 ? h.scrollTop / max : 0) + ')';
    };
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    update();
  }

  /* ── text effects ──────────────────────────────────────────── */
  function typewriter(el) {
    var text = el.dataset.ngText;
    el.style.visibility = 'visible';
    el.textContent = '';
    el.style.borderRight = '2px solid ' + GREEN;
    var i = 0;
    var t = setInterval(function () {
      i += 1;
      el.textContent = text.slice(0, i);
      if (i >= text.length) {
        clearInterval(t);
        later(function () {
          el.style.borderRight = 'none';
        }, 350);
      }
    }, 16);
    timers.push(t);
  }

  function scramble(el, speed) {
    var text = el.dataset.ngText;
    if (!text) return;
    el.style.visibility = 'visible';
    var total = Math.max(1, Math.round(text.length * 2.2));
    var frame = 0;
    if (el.ngScrambleTimer) clearInterval(el.ngScrambleTimer);
    var t = setInterval(function () {
      frame += 1;
      var settled = Math.floor((frame / total) * text.length);
      var out = '';
      for (var i = 0; i < text.length; i++) {
        if (i < settled || text[i] === ' ') {
          out += text[i];
        } else {
          out += SCRAMBLE_CHARS[Math.floor(Math.random() * SCRAMBLE_CHARS.length)];
        }
      }
      el.textContent = out;
      if (settled >= text.length) {
        el.textContent = text;
        clearInterval(t);
        el.ngScrambleTimer = null;
      }
    }, 30 * (speed || 1));
    el.ngScrambleTimer = t;
    timers.push(t);
  }

  /* ── reveal engine ─────────────────────────────────────────── */
  function reveal(el) {
    var kind = el.dataset.rv;
    if (kind === 'rise') {
      el.style.transition = 'opacity 480ms linear, transform 560ms ' + SNAP;
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    } else if (kind === 'fade') {
      el.style.transition = 'opacity 420ms linear';
      el.style.opacity = '1';
    } else if (kind === 'stamp') {
      el.style.transition = 'opacity 200ms linear, transform 260ms ' + SNAP;
      el.style.opacity = '1';
      el.style.transform = 'scale(1)';
    } else if (kind === 'drawY') {
      el.style.transition = 'opacity 300ms linear, border-left-color 400ms linear';
      el.style.opacity = '1';
      el.style.borderLeftColor = GREEN;
    } else if (kind === 'specrow') {
      el.style.transition = 'opacity 300ms linear, transform 360ms ' + SNAP;
      el.style.opacity = '1';
      el.style.transform = 'translateX(0)';
    } else if (kind === 'type') {
      typewriter(el);
    } else if (kind === 'scr') {
      scramble(el, 1);
    }
  }

  function setupReveals() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-rv]'));
    if (!els.length) return;

    if (reduced || !('IntersectionObserver' in window)) return;

    els.forEach(function (el) {
      var kind = el.dataset.rv;
      if (!el.dataset.ngText && (kind === 'type' || kind === 'scr')) {
        el.dataset.ngText = el.textContent;
      }
      el.style.transition = 'none';
      if (kind === 'rise') {
        el.style.opacity = '0';
        el.style.transform = 'translateY(26px)';
      } else if (kind === 'fade') {
        el.style.opacity = '0';
      } else if (kind === 'stamp') {
        el.style.opacity = '0';
        el.style.transform = 'scale(1.12)';
      } else if (kind === 'drawY') {
        el.style.borderLeftColor = 'transparent';
        el.style.opacity = '0';
      } else if (kind === 'specrow') {
        el.style.opacity = '0';
        el.style.transform = 'translateX(-14px)';
      } else if (kind === 'type' || kind === 'scr') {
        el.style.visibility = 'hidden';
      }
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          io.unobserve(el);
          later(function () {
            reveal(el);
          }, parseInt(el.dataset.rvD || '0', 10));
        });
      },
      { threshold: 0.12 }
    );
    els.forEach(function (el) {
      io.observe(el);
    });
    activeObserver = io;
  }

  /* ── hero media scan reveal + idle loop ────────────────────── */
  function setupHeroMedia() {
    var visuals = document.querySelectorAll('[data-hero-visual]');
    Array.prototype.forEach.call(visuals, function (visual) {
      var img = visual.querySelector('[data-hero-media]') || visual.querySelector('img');
      var line = visual.querySelector('[data-hero-scanline]');
      var idle = visual.querySelector('[data-idle-scan]');
      var label = visual.querySelector('[data-hero-label]');
      var crosses = visual.querySelectorAll('[data-crosshair]');
      if (!img) return;

      if (reduced) {
        img.style.clipPath = 'none';
        if (idle) idle.style.animation = 'none';
        return;
      }

      img.style.clipPath = 'inset(0 0 100% 0)';
      if (label) {
        label.style.opacity = '0';
        label.style.transform = 'scale(1.1)';
      }
      Array.prototype.forEach.call(crosses, function (c) {
        c.style.opacity = '0';
        c.style.transform = 'scale(1.6)';
      });

      later(function () {
        var D = 1100;
        img.style.transition = 'clip-path ' + D + 'ms ' + SNAP;
        img.style.clipPath = 'inset(0 0 0% 0)';
        if (line) {
          line.style.opacity = '1';
          line.style.transition = 'top ' + D + 'ms ' + SNAP;
          line.style.top = '100%';
          later(function () {
            line.style.transition = 'opacity 300ms linear';
            line.style.opacity = '0';
          }, D);
        }
        later(function () {
          Array.prototype.forEach.call(crosses, function (c, i) {
            later(function () {
              c.style.transition = 'opacity 160ms linear, transform 220ms ' + SNAP;
              c.style.opacity = '1';
              c.style.transform = 'scale(1)';
              c.style.animation = 'ngCrossPulse 4s ease-in-out ' + (2 + i) + 's infinite';
            }, i * 140);
          });
          if (label) {
            later(function () {
              label.style.transition = 'opacity 180ms linear, transform 240ms ' + SNAP;
              label.style.opacity = '1';
              label.style.transform = 'scale(1)';
              label.style.animation = 'ngBlink 340ms steps(2, jump-none) 2 240ms';
            }, 300);
          }
          if (idle && visual.hasAttribute('data-idle-scan-loop')) {
            idle.style.animation = 'ngScanIdle 9s linear 3s infinite';
          }
        }, D * 0.85);
      }, 300);
    });
  }

  /* ── product card hover scramble ───────────────────────────── */
  function setupCardScramble() {
    if (reduced) return;
    document.addEventListener(
      'mouseenter',
      function (e) {
        if (!e.target || !e.target.closest) return;
        var card = e.target.closest('[data-card-scramble]');
        if (!card || card.ngHovered) return;
        card.ngHovered = true;
        var pn = card.querySelector('[data-card-pn]');
        if (pn) {
          if (!pn.dataset.ngText) pn.dataset.ngText = pn.textContent;
          scramble(pn, 0.7);
        }
      },
      true
    );
    document.addEventListener(
      'mouseleave',
      function (e) {
        if (!e.target || !e.target.closest) return;
        var card = e.target.closest ? e.target.closest('[data-card-scramble]') : null;
        if (card) card.ngHovered = false;
      },
      true
    );
  }

  /* ── sticky add-to-cart (product view) ─────────────────────── */
  function setupStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    var trigger = document.querySelector('[data-sticky-atc-trigger]');
    if (!bar || !trigger || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        var visible = entries[0].isIntersecting;
        bar.style.transform = visible
          ? 'translateX(-50%) translateY(calc(100% + 60px))'
          : 'translateX(-50%) translateY(0)';
        bar.style.opacity = visible ? '0' : '1';
        bar.toggleAttribute('data-sticky-atc-open', !visible);
      },
      { threshold: 0 }
    );
    io.observe(trigger);
  }

  /* ── reduced-motion flip: reveal everything instantly ──────── */
  function revealAllInstantly() {
    if (activeObserver) {
      activeObserver.disconnect();
      activeObserver = null;
    }
    Array.prototype.forEach.call(document.querySelectorAll('[data-rv]'), function (el) {
      el.style.transition = 'none';
      el.style.opacity = '';
      el.style.transform = '';
      el.style.visibility = '';
      el.style.borderLeftColor = '';
      var kind = el.dataset.rv;
      if ((kind === 'type' || kind === 'scr') && el.dataset.ngText) {
        el.textContent = el.dataset.ngText;
        el.style.borderRight = 'none';
      }
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-hero-visual]'), function (visual) {
      var img = visual.querySelector('[data-hero-media]') || visual.querySelector('img');
      if (img) img.style.clipPath = 'none';
      Array.prototype.forEach.call(
        visual.querySelectorAll('[data-crosshair], [data-hero-label]'),
        function (el) {
          el.style.opacity = '';
          el.style.transform = '';
        }
      );
      var idle = visual.querySelector('[data-idle-scan]');
      if (idle) idle.style.animation = 'none';
      var line = visual.querySelector('[data-hero-scanline]');
      if (line) line.style.opacity = '0';
    });
    timers.forEach(function (t) {
      clearTimeout(t);
      clearInterval(t);
    });
    timers = [];
  }

  if (reducedQuery) {
    var onReducedChange = function (e) {
      reduced = e.matches;
      if (reduced) revealAllInstantly();
    };
    if (reducedQuery.addEventListener) {
      reducedQuery.addEventListener('change', onReducedChange);
    } else if (reducedQuery.addListener) {
      reducedQuery.addListener(onReducedChange);
    }
  }

  /* ── boot ──────────────────────────────────────────────────── */
  function init() {
    setupScrollTrace();
    setupReveals();
    setupHeroMedia();
    setupCardScramble();
    setupStickyAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Replay entry animations when the theme editor re-renders a section.
  document.addEventListener('shopify:section:load', function () {
    timers.forEach(function (t) {
      clearTimeout(t);
      clearInterval(t);
    });
    timers = [];
    if (activeObserver) {
      activeObserver.disconnect();
      activeObserver = null;
    }
    setupReveals();
    setupHeroMedia();
    setupStickyAtc();
  });
})();
